import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { InstallProvider } from "@/contexts/InstallContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import InstallPrompt from "@/components/InstallPrompt";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Warehouses from "@/pages/Warehouses";
import StockReceipts from "@/pages/StockReceipts";
import Recipes from "@/pages/Recipes";
import Production from "@/pages/Production";
import Dispatch from "@/pages/Dispatch";
import BranchReceipts from "@/pages/BranchReceipts";
import Transfers from "@/pages/Transfers";
import HistoryPage from "@/pages/History";
import WriteOffs from "@/pages/WriteOffs";
import Attendance from "@/pages/Attendance";
import AttendanceAdmin from "@/pages/AttendanceAdmin";
import Inventory from "@/pages/Inventory";
import CoffeeTracking from "@/pages/CoffeeTracking";
import Admin from "@/pages/Admin";

const guard = (key, element) => <ProtectedRoute permissionKey={key}>{element}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <InstallProvider>
        <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={guard("dashboard", <Dashboard />)} />
              <Route path="/sklady" element={guard("warehouses", <Warehouses />)} />
              <Route path="/prijem" element={guard("receipts", <StockReceipts />)} />
              <Route path="/postupy" element={guard("recipes", <Recipes />)} />
              <Route path="/vyroba" element={guard("production", <Production />)} />
              <Route path="/expedice" element={guard("dispatch", <Dispatch />)} />
              <Route path="/pobocka-prijem" element={guard("branch_receipts", <BranchReceipts />)} />
              <Route path="/prevody" element={guard("transfers", <Transfers />)} />
              <Route path="/odpisy" element={guard("writeoffs", <WriteOffs />)} />
              <Route path="/inventury" element={guard("inventory", <Inventory />)} />
              <Route path="/kava" element={guard("coffee", <CoffeeTracking />)} />
              <Route path="/dochazka" element={guard("attendance", <Attendance />)} />
              <Route path="/dochazka-prehled" element={guard("attendance_admin", <AttendanceAdmin />)} />
              <Route path="/historie" element={guard("history", <HistoryPage />)} />
              <Route
                path="/administrace"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          richColors
          position="top-right"
          style={{ marginTop: "env(safe-area-inset-top, 0px)" }}
        />
        <InstallPrompt />
        </div>
      </InstallProvider>
    </AuthProvider>
  );
}

export default App;
